import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_REQUESTS: '/GetRequestLists',
  GET_ALL_REQUESTCATEGORIES: '/GetRequestLists',
  SEND_ANSWER: '/AnswerToRequest/',
  GET_REQUEST_OPTIONS: '/RequestOptionsYntList/',
  GET_REQUESTCATEGORIES_OPTIONS: '/CitizenCategoryList/',  DELETE_REQUEST_ADDRESS: '/RequestRemove', DELETE_REQ_GROUP: '/CitizenCategoryDelete',
  ADD_REQCATEGORIES:'/CitizenCategoryAdd',
  UPDATE_REQCATEGORIES:'/CitizenCategoryUpdate',
  UPDATE_REQUEST_STATUS: '/RequestDurumDegis',
  GET_REQUEST_LIST_EXCEL: '/GetRequestListsExcel',
  HAZIR_CEVAP_LIST: '/HazirCevapList',
  HAZIR_CEVAP_ADD: '/HazirCevapAdd',
  HAZIR_CEVAP_UPDATE: '/HazirCevapUpdate',
  HAZIR_CEVAP_DELETE: '/HazirCevapDelete'
};

const PHOTO_BASE_URL = process.env.PHOTO_BASE_URL || 'https://apiizdonusum.izmirteknoloji.com.tr/YuklenenDosyalar';

export const REQUEST_CATEGORY_TYPES = ['Şikayet', 'Talep', 'Bilgi'];

export const getAllrequest =   async (params) => {
    const {type, count, offset, date, search,basla,bitis,durum} = params;
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_REQUESTS, { params: {type, count, offset, date, search,basla,bitis,durum} });
    return response.data;
  };
  export const getRequestOptions = async () => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUEST_OPTIONS);
    return response.data;
  };
  export const getRequesCategories = async () => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUESTCATEGORIES_OPTIONS);
    return response.data;
  };
  export const deleteReqCategories = async (userId) => {
    try {
      const response = await axiosInstance.post(`${ENDPOINTS.DELETE_REQ_GROUP}/${userId}`);
      if (response.data && response.data.status === 200) {
        return 1;
      }
      return 0;
    } catch (error) {
      return 0;
    }
  };
  export const createRequestCategories = async (userData) => {
    try {
      const formData = new FormData();
      formData.append('Adi', userData.adi);
      formData.append('Sira', userData.sira);
      formData.append('AktifMi', true);
      formData.append('Aciklama', userData.aciklama || '');
      formData.append('Tur', userData.tur);
      const response = await axiosInstance.post(ENDPOINTS.ADD_REQCATEGORIES, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data && response.data.status === 200) {
        return response.data;
      }
      throw new Error(response.data.message || 'Failed to create user');
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  };

  export const updateReqCategories = async (userId, userData) => {
    try {
      const formData = new FormData();
      formData.append('adi', userData.adi);   
      formData.append('sira', userData.sira);   
      formData.append('AktifMi',true);   
      formData.append('aciklama', userData.aciklama || '');
      formData.append('tur', userData.tur);
      const response = await axiosInstance.post(`${ENDPOINTS.UPDATE_REQCATEGORIES}/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.data && response.data.status === 200) {
        return response.data;
      }
      throw new Error(response.data.message || 'Failed to update user');
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  };
  export const deleteRequest = async (id) => {
    const response = await axiosInstance.post(ENDPOINTS.DELETE_REQUEST_ADDRESS + '/' + id);
    return response.data;
  };

  export const sendAnswer = async (requestId, { text, image, hazirCevapId }) => {
    const formData = new FormData();
    formData.append("RequestId", requestId); 
    formData.append("Answer", text);        
    if (image) formData.append("image", image); 
    // Backend yeni dosya gelmezse resmi bu hazır cevaptan alacak (IP-351 yorumu).
    else if (hazirCevapId) formData.append("HazirCevapId", hazirCevapId);

    const response = await axiosInstance.post(
      `${ENDPOINTS.SEND_ANSWER}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  };

  export const updateRequestStatus = async ({ id, durum }) => {
    const response = await axiosInstance.put(ENDPOINTS.UPDATE_REQUEST_STATUS, { id, durum });
    return response.data;
  };

  export const sendNotificationCavus = async (requestId) => {
    const response = await axiosInstance.post('/SendNotificationCavus', { RequestId: requestId });
    return response.data;
  };

  export const getRequestListExcel = async (params = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.GET_REQUEST_LIST_EXCEL, {
      params,
      responseType: 'blob',
    });
    return response.data;
  };

  export const getHazirCevapImageUrl = (resim) => {
    if (!resim) return null;
    return /^https?:\/\//.test(resim) ? resim : `${PHOTO_BASE_URL}/${resim}`;
  };

  export const getHazirCevaplar = async (tipId) => {
    const response = await axiosInstance.get(ENDPOINTS.HAZIR_CEVAP_LIST, { params: { tipId } });
    return response.data?.data || [];
  };

  const buildHazirCevapForm = ({ cevap, tipId, resim }) => {
    const formData = new FormData();
    formData.append('Cevap', cevap);
    formData.append('TipId', tipId);
    if (resim) formData.append('Resim', resim);
    return formData;
  };

  export const addHazirCevap = async (data) => {
    const response = await axiosInstance.post(ENDPOINTS.HAZIR_CEVAP_ADD, buildHazirCevapForm(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  };

  export const updateHazirCevap = async (id, data) => {
    const response = await axiosInstance.post(`${ENDPOINTS.HAZIR_CEVAP_UPDATE}/${id}`, buildHazirCevapForm(data), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  };

  export const deleteHazirCevap = async (id) => {
    const response = await axiosInstance.post(`${ENDPOINTS.HAZIR_CEVAP_DELETE}/${id}`);
    return response.data;
  };
